// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__0g81b","tyre":"style_tyre__Jpo8i"};